import React, { useState } from 'react'
import { FormControl, FormLabel } from '@mui/material'
import Input from 'src/components/Input'
import { useAppDispatch, useAppSelect } from 'src/hooks/useRedux'

import { setPayload } from '../../ducks/home.reducer'

const validateNINO = (value: string): string => {
  // Empty values are allowed
  if (!value || value.trim() === '') {
    return ''
  }

  // Sanitize: remove spaces/hyphens, convert to uppercase
  const sanitized = value.replace(/[\s-]/g, '').toUpperCase()

  // Format pattern check
  const pattern = /^[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z][0-9]{6}[A-D]$/
  if (!pattern.test(sanitized)) {
    return 'Please enter a valid National Insurance Number, like AB123456C'
  }

  // Invalid prefixes check
  const prefix = sanitized.substring(0, 2)
  const invalidPrefixes = ['BG', 'GB', 'NK', 'KN', 'TN', 'NT', 'ZZ']
  if (invalidPrefixes.includes(prefix)) {
    return 'Please enter a valid National Insurance Number, like AB123456C'
  }

  return ''
}

const NationalInsuranceNo: React.FC = () => {
  const { payload } = useAppSelect((state) => state.home)
  const dispatch = useAppDispatch()
  const [error, setError] = useState<string>('')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    // Sanitize: remove spaces/hyphens, convert to uppercase
    const sanitized = value.replace(/[\s-]/g, '').toUpperCase()

    // Validate and set error
    const validationError = validateNINO(sanitized)
    setError(validationError)

    // Store sanitized value in Redux
    dispatch(
      setPayload({
        ...payload,
        nino: sanitized,
      }),
    )
  }

  return (
    <FormControl sx={{ width: '100%' }}>
      <FormLabel
        sx={{
          fontSize: (theme) => theme.typography.fontSize + 2,
          fontWeight: (theme) => theme.typography.fontWeightRegular,
        }}
      >
        National Insurance Number
      </FormLabel>
      <Input
        value={payload.nino}
        onChange={handleChange}
        placeholder="Enter national insurance number"
        error={!!error}
        helperText={error}
        inputProps={{ maxLength: 9 }}
      />
    </FormControl>
  )
}

export default NationalInsuranceNo
